export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  cover: string;
  author: string;
  category: string;
  categorySlug: string;
  tags: string[];
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updateDate: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '悬疑', slug: 'mystery' },
  { name: '搞笑', slug: 'comedy' },
  { name: '剧情', slug: 'drama' },
  { name: '耽美', slug: 'bl' },
  { name: '百合', slug: 'gl' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '她的秘密花园',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20young%20woman%20in%20a%20secret%20garden%20full%20of%20blooming%20flowers%2C%20soft%20romantic%20atmosphere%2C%20warm%20pastel%20colors%2C%20delicate%20lineart%2C%20shojo%20manga%20aesthetic%2C%20clean%20composition%20on%20light%20cream%20background&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    author: '金智恩',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '都市', '甜宠'],
    description: '平凡的女大学生林小曼，某天意外发现学校后山隐藏着一座神秘花园。在那里，她遇见了神秘的美少年韩星辰。两人在花园中渐渐走近，但韩星辰身上似乎藏着不为人知的秘密...一段跨越现实与梦幻的浪漫爱情故事就此展开。',
    rating: 9.5,
    views: 1280000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-001-1', title: '第1话 秘密的入口', chapterNumber: 1, updateDate: '2026-06-01' },
      { id: 'ch-001-2', title: '第2话 花园的主人', chapterNumber: 2, updateDate: '2026-06-08' },
      { id: 'ch-001-3', title: '第3话 心跳的距离', chapterNumber: 3, updateDate: '2026-06-15' },
      { id: 'ch-001-4', title: '第4话 雨中的约定', chapterNumber: 4, updateDate: '2026-06-22' },
      { id: 'ch-001-5', title: '第5话 不速之客', chapterNumber: 5, updateDate: '2026-07-01' },
      { id: 'ch-001-6', title: '第6话 隐藏在星光下', chapterNumber: 6, updateDate: '2026-07-08' },
      { id: 'ch-001-7', title: '第7话 命运的转折', chapterNumber: 7, updateDate: '2026-07-15' },
      { id: 'ch-001-8', title: '第8话 告白之夜', chapterNumber: 8, updateDate: '2026-07-22' },
      { id: 'ch-001-9', title: '第9话 新的开始', chapterNumber: 9, updateDate: '2026-07-29' },
      { id: 'ch-001-10', title: '第10话 花园的真相', chapterNumber: 10, updateDate: '2026-08-03' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-002',
    title: '暗夜之王',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20powerful%20male%20protagonist%20with%20shadowy%20aura%2C%20dark%20royal%20aesthetic%2C%20mysterious%20atmosphere%2C%20gothic%20elements%2C%20deep%20crimson%20and%20black%20color%20scheme%2C%20dramatic%20lighting%2C%20action%20manhwa%20style&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    author: '朴志浩',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '战斗', '异能'],
    description: '在一个人与魔共存的世界里，平凡高中生李黑暗某天觉醒了传说中的暗夜之力。被卷入魔界权力斗争的他，必须在人类世界与魔界之间找到平衡，成为新的暗夜之王。热血战斗与深刻友情的奇幻巨作！',
    rating: 9.7,
    views: 2560000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-002-1', title: '第1话 觉醒之日', chapterNumber: 1, updateDate: '2026-05-15' },
      { id: 'ch-002-2', title: '第2话 黑暗之力', chapterNumber: 2, updateDate: '2026-05-22' },
      { id: 'ch-002-3', title: '第3话 魔界之门', chapterNumber: 3, updateDate: '2026-05-29' },
      { id: 'ch-002-4', title: '第4话 初战', chapterNumber: 4, updateDate: '2026-06-05' },
      { id: 'ch-002-5', title: '第5话 王的试炼', chapterNumber: 5, updateDate: '2026-06-12' },
      { id: 'ch-002-6', title: '第6话 同伴', chapterNumber: 6, updateDate: '2026-06-19' },
      { id: 'ch-002-7', title: '第7话 背叛', chapterNumber: 7, updateDate: '2026-06-26' },
      { id: 'ch-002-8', title: '第8话 决战前夕', chapterNumber: 8, updateDate: '2026-07-03' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-003',
    title: '甜蜜的陷阱',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Korean%20manhwa%20cover%20of%20a%20couple%20sharing%20a%20tender%20moment%20in%20a%20cozy%20cafe%2C%20warm%20golden%20lighting%2C%20soft%20color%20palette%2C%20modern%20romance%20aesthetic%2C%20cute%20and%20heartwarming%20atmosphere%2C%20clean%20illustration%20style&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    author: '崔美英',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '甜宠', '日常'],
    description: '甜品师苏甜甜在首尔最热门的面包店工作，某天一位冷酷的金融分析师搬到了隔壁。两人从互看不顺眼到慢慢被对方吸引，甜蜜又搞笑的都市恋爱喜剧。每一话都让人心动不已！',
    rating: 9.3,
    views: 980000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-003-1', title: '第1话 新邻居', chapterNumber: 1, updateDate: '2026-06-20' },
      { id: 'ch-003-2', title: '第2话 草莓蛋糕', chapterNumber: 2, updateDate: '2026-06-27' },
      { id: 'ch-003-3', title: '第3话 意外的约会', chapterNumber: 3, updateDate: '2026-07-04' },
      { id: 'ch-003-4', title: '第4话 心跳咖啡因', chapterNumber: 4, updateDate: '2026-07-11' },
      { id: 'ch-003-5', title: '第5话 雨天的告白', chapterNumber: 5, updateDate: '2026-07-18' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-004',
    title: '剑与魔法学院',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20showing%20students%20at%20a%20magical%20academy%20with%20swords%20and%20spell%20effects%2C%20vibrant%20magical%20auras%2C%20dynamic%20action%20pose%2C%20bright%20adventure%20atmosphere%2C%20colorful%20magic%20circles%2C%20anime%20inspired%20illustration%20style&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    author: '李贤宇',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '学院', '冒险'],
    description: '出身平民的天才少年金剑心，凭借超凡天赋被大陆最顶尖的剑与魔法学院录取。在这里，他结识了来自各大家族的伙伴，共同面对学院中的挑战与隐藏在暗处的阴谋。热血的学院奇幻冒险！',
    rating: 9.4,
    views: 1890000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-004-1', title: '第1话 入学考试', chapterNumber: 1, updateDate: '2026-04-10' },
      { id: 'ch-004-2', title: '第2话 宿舍分配', chapterNumber: 2, updateDate: '2026-04-17' },
      { id: 'ch-004-3', title: '第3话 第一堂课', chapterNumber: 3, updateDate: '2026-04-24' },
      { id: 'ch-004-4', title: '第4话 实战训练', chapterNumber: 4, updateDate: '2026-05-01' },
      { id: 'ch-004-5', title: '第5话 地下迷宫', chapterNumber: 5, updateDate: '2026-05-08' },
      { id: 'ch-004-6', title: '第6话 团队合作', chapterNumber: 6, updateDate: '2026-05-15' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-005',
    title: '谜案追踪',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20manhwa%20cover%20with%20a%20detective%20examining%20clues%20under%20dim%20streetlight%2C%20noir%20atmosphere%2C%20rainy%20urban%20setting%2C%20suspenseful%20mood%2C%20dark%20blue%20and%20gray%20tones%2C%20mysterious%20silhouette%2C%20crime%20investigation%20theme&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    author: '郑泰浩',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '推理', '犯罪'],
    description: '前刑警姜泰浩因一次失误被调离一线，成为了一名私人侦探。某天，一桩看似普通的失踪案将他卷入了一场跨越十年的连环命案。每一个线索都指向一个惊人的真相。紧张刺激的悬疑推理漫画！',
    rating: 9.6,
    views: 1560000,
    status: '已完结',
    updateDate: '2026-07-28',
    chapters: [
      { id: 'ch-005-1', title: '第1话 失踪', chapterNumber: 1, updateDate: '2026-03-15' },
      { id: 'ch-005-2', title: '第2话 第一具尸体', chapterNumber: 2, updateDate: '2026-03-22' },
      { id: 'ch-005-3', title: '第3话 十年前的秘密', chapterNumber: 3, updateDate: '2026-03-29' },
      { id: 'ch-005-4', title: '第4话 嫌疑人', chapterNumber: 4, updateDate: '2026-04-05' },
      { id: 'ch-005-5', title: '第5话 揭露', chapterNumber: 5, updateDate: '2026-04-12' },
      { id: 'ch-005-6', title: '第6话 真相（上）', chapterNumber: 6, updateDate: '2026-04-19' },
      { id: 'ch-005-7', title: '第7话 真相（下）', chapterNumber: 7, updateDate: '2026-04-26' },
      { id: 'ch-005-8', title: '第8话 终章', chapterNumber: 8, updateDate: '2026-05-03' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-006',
    title: '爆笑校园日常',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20Korean%20manhwa%20cover%20showing%20students%20in%20hilarious%20situations%20at%20school%2C%20exaggerated%20expressions%2C%20bright%20and%20vibrant%20colors%2C%20cartoonish%20comedy%20style%2C%20energetic%20and%20playful%20atmosphere%2C%20school%20setting&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    author: '姜民秀',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '校园', '日常'],
    description: '普通高中二年级的日常能有多搞笑？金搞笑和他的奇葩同学们每天都在上演令人捧腹的校园喜剧。从课堂恶作剧到食堂大作战，没有一天是无聊的！让你笑到停不下来的轻松漫画。',
    rating: 9.1,
    views: 2100000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-006-1', title: '第1话 开学第一天', chapterNumber: 1, updateDate: '2026-01-10' },
      { id: 'ch-006-2', title: '第2话 食堂大作战', chapterNumber: 2, updateDate: '2026-01-17' },
      { id: 'ch-006-3', title: '第3话 考试噩梦', chapterNumber: 3, updateDate: '2026-01-24' },
      { id: 'ch-006-4', title: '第4话 体育课的灾难', chapterNumber: 4, updateDate: '2026-02-01' },
      { id: 'ch-006-5', title: '第5话 校园祭', chapterNumber: 5, updateDate: '2026-02-08' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-007',
    title: '命运轮回',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20about%20reincarnation%20and%20fate%2C%20a%20woman%20surrounded%20by%20ethereal%20threads%20of%20destiny%2C%20celestial%20background%2C%20emotional%20expression%2C%20deep%20storytelling%20vibe%2C%20melancholic%20yet%20hopeful%20atmosphere%2C%20beautiful%20artistic%20illustration&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    author: '宋智慧',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '轮回', '虐心'],
    description: '活了九十九次人生的尹素拉，在第一百次生命中决定不再爱上任何人。但命运却让她遇见了跨越轮回也在寻找她的那个人。一段跨越时空的深刻爱情故事，每一世的选择都牵动着下一世的命运。',
    rating: 9.8,
    views: 3200000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-007-1', title: '第1话 第九十九次死亡', chapterNumber: 1, updateDate: '2026-02-14' },
      { id: 'ch-007-2', title: '第2话 轮回的规则', chapterNumber: 2, updateDate: '2026-02-21' },
      { id: 'ch-007-3', title: '第3话 熟悉的陌生人', chapterNumber: 3, updateDate: '2026-02-28' },
      { id: 'ch-007-4', title: '第4话 前世的记忆', chapterNumber: 4, updateDate: '2026-03-07' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-008',
    title: '武林至尊',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20action%20Korean%20manhwa%20cover%20with%20a%20warrior%20in%20traditional%20martial%20arts%20pose%2C%20dynamic%20fighting%20stance%2C%20epic%20mountain%20background%2C%20ink%20wash%20painting%20style%20influence%2C%20powerful%20energy%20effects%2C%20heroic%20atmosphere&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    author: '张武烈',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '武侠', '热血'],
    description: '少年张天命，出身武学世家却天生经脉闭塞。在一次意外中获得了上古武神传承，从此踏上逆天改命之路。各路高手云集，武林风云再起！热血澎湃的武侠动作巨制！',
    rating: 9.2,
    views: 1750000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-008-1', title: '第1话 废柴少年', chapterNumber: 1, updateDate: '2026-05-20' },
      { id: 'ch-008-2', title: '第2话 武神传承', chapterNumber: 2, updateDate: '2026-05-27' },
      { id: 'ch-008-3', title: '第3话 初入江湖', chapterNumber: 3, updateDate: '2026-06-03' },
      { id: 'ch-008-4', title: '第4话 第一战', chapterNumber: 4, updateDate: '2026-06-10' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-009',
    title: '星光下的我们',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20BL%20Korean%20manhwa%20cover%20with%20two%20young%20men%20under%20starry%20night%20sky%2C%20tender%20emotional%20moment%2C%20soft%20blue%20and%20silver%20color%20scheme%2C%20dreamy%20atmosphere%2C%20delicate%20art%20style%2C%20shounen%20ai%20aesthetic&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    author: '韩月',
    category: '耽美',
    categorySlug: 'bl',
    tags: ['耽美', '治愈', '音乐'],
    description: '钢琴天才沈星辰与街头歌手陆月光，两个来自完全不同世界的少年，因音乐而相遇。在星光下，他们找到了彼此灵魂的共鸣。一部关于音乐、梦想与爱情的治愈系漫画。',
    rating: 9.4,
    views: 1450000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-009-1', title: '第1话 街头的声音', chapterNumber: 1, updateDate: '2026-07-01' },
      { id: 'ch-009-2', title: '第2话 琴房', chapterNumber: 2, updateDate: '2026-07-08' },
      { id: 'ch-009-3', title: '第3话 合奏', chapterNumber: 3, updateDate: '2026-07-15' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-010',
    title: '姐妹情深',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20GL%20Korean%20manhwa%20cover%20with%20two%20young%20women%20sharing%20a%20close%20friendship%20moment%2C%20soft%20pink%20and%20lavender%20color%20palette%2C%20gentle%20atmosphere%2C%20floral%20elements%2C%20delicate%20and%20elegant%20illustration%20style%2C%20yuri%20aesthetic&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    author: '安素英',
    category: '百合',
    categorySlug: 'gl',
    tags: ['百合', '治愈', '日常'],
    description: '大学室友李花英和朴素英，从最初的陌生人到无话不谈的挚友，再到超越友谊的特殊情感。在这个春天，两颗心慢慢靠近，谱写一段温暖美好的校园爱情故事。',
    rating: 9.3,
    views: 890000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-010-1', title: '第1话 新室友', chapterNumber: 1, updateDate: '2026-07-10' },
      { id: 'ch-010-2', title: '第2话 第一次晚餐', chapterNumber: 2, updateDate: '2026-07-17' },
      { id: 'ch-010-3', title: '第3话 图书馆的午后', chapterNumber: 3, updateDate: '2026-07-24' },
      { id: 'ch-010-4', title: '第4话 樱花下的约定', chapterNumber: 4, updateDate: '2026-07-31' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-011',
    title: '神级玩家',
    cover: 'https://readdy.ai/api/search-image?query=A%20gaming%20action%20Korean%20manhwa%20cover%20showing%20a%20player%20in%20virtual%20reality%20game%20world%2C%20futuristic%20game%20interface%2C%20epic%20battle%20scene%2C%20neon%20lights%2C%20digital%20effects%2C%20dynamic%20composition%2C%20thrilling%20adventure%20vibe&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    author: '刘炫硕',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '游戏', '竞技'],
    description: '被原战队背叛的职业选手韩胜负，以新身份重返虚拟现实游戏《神域》。凭借十年的游戏经验和超强实力，他将在游戏中掀起一场风暴，夺回属于自己的一切！',
    rating: 9.0,
    views: 1350000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-011-1', title: '第1话 退役', chapterNumber: 1, updateDate: '2026-06-15' },
      { id: 'ch-011-2', title: '第2话 新角色', chapterNumber: 2, updateDate: '2026-06-22' },
      { id: 'ch-011-3', title: '第3话 初见锋芒', chapterNumber: 3, updateDate: '2026-06-29' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-012',
    title: '时间旅人',
    cover: 'https://readdy.ai/api/search-image?query=A%20time%20travel%20mystery%20Korean%20manhwa%20cover%20with%20a%20person%20walking%20through%20clock%20gears%20and%20time%20portals%2C%20surreal%20atmosphere%2C%20golden%20and%20sepia%20tones%2C%20steampunk%20elements%2C%20mysterious%20and%20intriguing%20visual%2C%20intricate%20details&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    author: '陈智雅',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '时间', '科幻'],
    description: '物理学家林时间发现了一种可以穿越时空的方法，但每次穿越都会改变现实。当他试图拯救已故的未婚妻时，却发现每一次改变都带来更可怕的后果。令人窒息的时空悬疑大作！',
    rating: 9.5,
    views: 1670000,
    status: '已完结',
    updateDate: '2026-07-20',
    chapters: [
      { id: 'ch-012-1', title: '第1话 时间方程式', chapterNumber: 1, updateDate: '2026-04-01' },
      { id: 'ch-012-2', title: '第2话 第一次穿越', chapterNumber: 2, updateDate: '2026-04-08' },
      { id: 'ch-012-3', title: '第3话 蝴蝶效应', chapterNumber: 3, updateDate: '2026-04-15' },
      { id: 'ch-012-4', title: '第4话 时间悖论', chapterNumber: 4, updateDate: '2026-04-22' },
      { id: 'ch-012-5', title: '第5话 最终选择', chapterNumber: 5, updateDate: '2026-04-29' },
    ],
    isHot: false,
    isNew: false,
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getLatestUpdates(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
}

export const siteInfo = {
  name: '韩漫网',
  tagline: '免费韩漫大全 · 好看的韩国漫画 · 无删减下拉式在线观看',
  description: '韩漫网汇集了众多好看韩国漫画，所有内容均为无删减版本，采用下拉式在线观看技术，让您无需等待加载即可流畅阅读，随时随地享受漫画乐趣。',
  url: 'https://www.hanmanwang.com',
  email: 'contact@hanmanwang.com',
  established: '2020',
  comicCount: 5000,
  dailyUsers: 300000,
  totalViews: 50000000,
};